export const WaterKey = {
  WATER_SOURCE: 'source',
  WATER_WITHDRAWN_TF: 'totalwaterwithdrawal',
  WATER_CONSUMED_TF: 'totalwaterconsumed',
  WATER_COST_TF: 'watercost',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const WaterLabel = {
  WATER_SOURCE: 'Water Source',
  WATER_WITHDRAWN_TF: 'Total Water Withdrawn',
  WATER_CONSUMED_TF: 'Total Water Consumed',
  WATER_COST_TF: 'Water Cost',
  STATUS: 'Status',
  COMMENT: 'Comment',
  STATUS_COMMENTS: 'Status & Comments'
};

export const WaterTooltip = {
  WATER_WITHDRAWN_TF: `Total volume of water extracted from all sources (surface water, groundwater,
     seawater, and third-party sources) within the reporting period.`,
  WATER_CONSUMED_TF:
    `Total volume of water that is not returned to any water source after use within the reporting period.
     Calculated as: Total Water Withdrawn minus Total Water Discharged.`
};
